"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OfferTag = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../../../contexts");
var _hooks = require("../../../../hooks");
var _models = require("../../../../models");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component to render offer tag with info about offer expiration or points expiration.
 */
const OfferTag = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    expiringPoints,
    isCampaignOffer,
    isValidityVisible,
    offerValidity,
    pointsExpirationDays
  } = (0, _contexts.useOfferDetail)();
  const {
    isHeartFormat
  } = (0, _contexts.useCheckoutOffers)();
  if (isValidityVisible && !isCampaignOffer) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
      "data-testid": getTestId(_models.TestId.Validity),
      variant: "tag",
      label: formatMessage('offerEndsX', {
        value: offerValidity
      })
    });
  }
  if (isCampaignOffer && expiringPoints) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
      "data-testid": getTestId(_models.TestId.ExpiringPoints),
      variant: "tag",
      label: formatMessage(isHeartFormat ? 'xHeartsExpireInYDays' : 'xPointsExpireInYDays', {
        value: expiringPoints,
        days: pointsExpirationDays
      })
    });
  }
  return null;
};
exports.OfferTag = OfferTag;